
import React from 'react';
import styles from './App.module.css';

function Footer() {
  return (
    <footer className={styles.footer}>
      <p className={styles.footerText}>© 2023 Dennis Karlsson</p>
      <p className={styles.footerText}>Contact: dennis.karlsson@example.com</p>
    </footer>
  );
}

export default Footer;
